/**
 * Welcome popup — exibe cupom de desconto na primeira visita à home
 */
(function () {
  const STORAGE_KEY = 'leep-welcome-popup-dismissed';
  const popup = document.querySelector('[data-welcome-popup]');
  if (!popup) return;

  const dialog      = popup.querySelector('[data-welcome-popup-dialog]');
  const copyBtn     = popup.querySelector('[data-welcome-coupon-copy]');
  const copyLabel   = popup.querySelector('[data-welcome-coupon-copy-label]');
  const couponDisplay = popup.querySelector('[data-welcome-coupon-display]');
  const couponCode  = popup.dataset.welcomeCouponCode || 'PRIMEIROLEEP';
  const delayMs     = parseInt(popup.dataset.welcomePopupDelay || '2000', 10);

  const isHome =
    document.body.classList.contains('template-index') ||
    window.location.pathname === '/' ||
    window.location.pathname === '';

  if (!isHome) return;

  if (couponDisplay) couponDisplay.textContent = couponCode;

  const isDismissed = () => {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
  };

  const markDismissed = () => {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch {}
  };

  let releaseFocusTrap = null;

  const open = () => {
    popup.hidden = false;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-scroll-locked');
    releaseFocusTrap = window.LeepFocusTrap?.activate(dialog) || null;
  };

  const close = () => {
    popup.classList.remove('is-open');
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-scroll-locked');
    releaseFocusTrap?.();
    releaseFocusTrap = null;
  };

  const dismiss = () => {
    markDismissed();
    close();
  };

  popup.querySelectorAll('[data-welcome-popup-close]').forEach(el => {
    el.addEventListener('click', dismiss);
  });

  popup.addEventListener('click', event => {
    if (!popup.classList.contains('is-open')) return;
    if (dialog && !dialog.contains(event.target)) dismiss();
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) dismiss();
  });

  copyBtn?.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(couponCode);
      if (copyLabel) {
        const original = copyLabel.textContent;
        copyLabel.textContent = copyBtn.dataset.copiedLabel || 'Copiado!';
        copyBtn.classList.add('is-copied');
        window.setTimeout(() => {
          copyLabel.textContent = original;
          copyBtn.classList.remove('is-copied');
        }, 2200);
      }
    } catch {
      const range = document.createRange();
      range.selectNodeContents(couponDisplay);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  });

  if (isDismissed()) return;

  window.setTimeout(() => {
    if (!isDismissed()) open();
  }, Math.max(0, delayMs));
})();
